export const getOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    if (/windows/i.test(userAgent)) {
      return "Windows";
    }
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "Unknown OS";
  };